/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Want_To_Customize_Your_Link_AnInputs */

const en_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to customize your link and branding?`)
};

const es_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Quieres personalizar tu enlace y marca?`)
};

const fr_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous souhaitez personnaliser votre lien et votre marque ?`)
};

const de_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Möchtest du deinen Link und dein Branding anpassen?`)
};

const ja_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リンクやブランディングをカスタマイズしますか？`)
};

const zh_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`想要自定义您的链接和品牌形象吗？`)
};

const ar_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل ترغب في تخصيص رابطك وعلامتك التجارية؟`)
};

const id_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingin menyesuaikan tautan dan branding Anda?`)
};

const it_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuoi personalizzare il tuo link e il branding?`)
};

const ru_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хотите настроить ссылку и бренд?`)
};

const pt_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quer personalizar o seu link e branding?`)
};

const ko_want_to_customize_your_link_an = /** @type {(inputs: Want_To_Customize_Your_Link_AnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`링크와 브랜딩을 커스터마이징하고 싶으신가요?`)
};

/**
* | output |
* | --- |
* | "Want to customize your link and branding?" |
*
* @param {Want_To_Customize_Your_Link_AnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const want_to_customize_your_link_an = /** @type {((inputs?: Want_To_Customize_Your_Link_AnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Want_To_Customize_Your_Link_AnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_want_to_customize_your_link_an(inputs)
	if (locale === "es") return es_want_to_customize_your_link_an(inputs)
	if (locale === "fr") return fr_want_to_customize_your_link_an(inputs)
	if (locale === "de") return de_want_to_customize_your_link_an(inputs)
	if (locale === "ja") return ja_want_to_customize_your_link_an(inputs)
	if (locale === "zh") return zh_want_to_customize_your_link_an(inputs)
	if (locale === "ar") return ar_want_to_customize_your_link_an(inputs)
	if (locale === "id") return id_want_to_customize_your_link_an(inputs)
	if (locale === "it") return it_want_to_customize_your_link_an(inputs)
	if (locale === "ru") return ru_want_to_customize_your_link_an(inputs)
	if (locale === "pt") return pt_want_to_customize_your_link_an(inputs)
	return ko_want_to_customize_your_link_an(inputs)
});